<template>
    <span class="hover_0" style="cursor:pointer;">
        <img v-if="null!=marked && marked"
          title="你关注了这个工单,点击可取消关注" 
          @click="_off"
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABf0lEQVQ4T52TvS9DYRTGn6fte8VAze29NxGRXgMDkZBYpJFYDFb+AB+7ycRsFf0HJAaT2DTdfAxCScRtJMS9YWWSuG9vj7QNWuoq73qe8zvnPOe8RMRzLbUFgI6vF3+S8aeAayElUPckE/FQxvsf9EkrbQRA5UAu1JPk0PH0RNsA1zSGQCmC/CwQVrLOQ7nwFdKyA9dWeYDZRrFAzgc8PfwNcJOGWYmrSRFWq45AMAays7U38grBsQBnMeIiFuoCXdu4BdAbtY2I2B2vTWOOMWz/ByAVzNc8cC21CXL5TxDBhuMHKzWAAPGSZeyDmG4LIpJzfL1U1X5sQYBEyVJHIEcjISKXGV8PEwibAPVRjD0QM1EAgeQHPD31rmm6A9dSlyAHfxnj1vGCvtYAWz0DTEZ2IFJ2fG2wZl2DB3c96HntNp7ek0XkgJS1uFc+DW1VNWwdYFf9awRpx8djE+AG6AhtoyjAVUywm/GDncZOSibSQrUq5GyyHPSlHvFSjb8BT4GGUFv6c6YAAAAASUVORK5CYII="/>
        <img v-if="null!=marked && !marked"
          title="点击关注这个工单" 
          @click="_on"
          src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABd0lEQVQ4T52Suy+DURjGnyeEaiLMGCpmBiIhsYhILAZLB/4Al73nNLF8bO/5pE2aCP+ARBqT2DQ2l0HcEiu1WJnaSquvfIIovhZnO3me9/deiTpPRDZI0hizEGZjmCAiXQDuSDar6qi19uQnbyjAObcJYP4t6NAYM/ZrgO/7A6p6AeAjAcmJRCJx8BXyYwUikgsCPptV9dxaO/gNICI9AMZJBlmHSI4AaAuZzROAY1U9I3mpqgd0zt0A6K23jTraLX3fn1XVrf8ASM69zkBE1kku/RGyZoxJvAKy2WxTPp/fAzD1G4iqblprFwPvxxY8z2uORqNHAIYbQK5isdhgPB5/rgEEH+fcLoDpBoCcMWby3VNzByJyRbK/HkBVb6y1fWGAR5IdDQAVY0wLSa1pIZ1Od5bL5Yf3YFXdJ7kSiUROi8ViMLBVku2Brqrd1tr7GkAmk2ktlUrB/V9Xq9WdZDK5/bmSVCrVXalUlgHMFAqFPs/zCoH+ArY6kT8+CaLVAAAAAElFTkSuQmCC"/>
    </span>
</template>

<script>
export default {
  name: "TicketMark",

  props : ["ticketNo"],

  data() {
      return {
        mode : '',
        marked : null
      };
  },

  watch : {
      ticketNo() {
          this._onLoad();
      }
  },

  mounted() {
    var _this = this;

    // 详情模式
    if ( "/ticket-vue/ticket/detail" == _this.$route.path ) {
      _this.mode = 'detail';
      _this.doLoad_0([this]);
      return;
    }

    // 列表模式
    if ( "/ticket-vue/ticket/view" == _this.$route.path ) {
      _this.mode = 'view';
    }

    this._onLoad();
  },

  methods: {
    _onLoad() {
      if ( !window.TicketMarkList ) {
        window.TicketMarkList = [];
      }

      window.TicketMarkList.push(this);

      clearTimeout(window.TicketMarkTimeoutId);
      window.TicketMarkTimeoutId = setTimeout(this._doLoad, 100);
    },

    _doLoad() {
      if ( !window.TicketMarkList ) {
        console.log("#47 window.TicketMarkList=", window.TicketMarkList);

        clearTimeout(window.TicketMarkTimeoutId);
        window.TicketMarkTimeoutId = setTimeout(this._doLoad, 1500); // 太快了？
        return;
      }

      this.doLoad_0(window.TicketMarkList);
    },

    doLoad_0(_ticketMarkList) {
      sdk.TicketMarkApi().listByTicketNos({
        nos : _ticketMarkList.map(e=>e.ticketNo)
      }).then(res=> {
        for ( var i=0; i<res.length; i++ ) {
            _ticketMarkList[i].marked = res[i];
        }

        // 清理
        window.TicketMarkTimeoutId = null;
        window.TicketMarkList = null;
      });
    }, 

    _on() {
      var _this = this;

      sdk.TicketMarkApi().insertByTicketNo({
          no : _this.ticketNo
      }).then(res=> {
        _this.marked = true;
        _message("关注工单成功");

        _this._dispatchEvent();
      });
    },

    _off() {
      var _this = this;

      sdk.TicketMarkApi().deleteByTicketNo({
        no : _this.ticketNo
      }).then(res=> {
        _this.marked = false;
        _message("取消关注工单成功");
        _this._dispatchEvent();
      });
    },

    _dispatchEvent() {
      window.dispatchEvent(new CustomEvent('event_load_ticket_view', {}));
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/ticket/TicketMark.vue